<template>
  <TabelaDeHoras></TabelaDeHoras>
</template>

<script lang="ts">

import TabelaDeHoras from './components/TabelaDeHoras.vue';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'App',
  components: {
    TabelaDeHoras
  }
}
);
</script>

<style></style>
